import api from './api'

export type ProfileChangeFilters = Partial<{
  employee: string | string[]
  changed_by: string | string[]
  field_name: string | string[]
  date_from: string // YYYY-MM-DD
  date_to: string   // YYYY-MM-DD
}>

export async function fetchProfileChanges({
  page,
  pageSize,
  filters = {},
}: {
  page: number
  pageSize: number
  filters?: ProfileChangeFilters
}) {
  const params: Record<string, any> = {
    page,
    page_size: pageSize,
    // Expand related users for display and restrict fields to only what's needed
    expand: 'employee,changed_by',
    fields:
      'employee.first_name,employee.last_name,employee.profile_picture,' +
      'changed_by.first_name,changed_by.last_name,changed_by.profile_picture,' +
      'field_name,previous_value,new_value,created_at,id',
  }

  // Map filters; when multiple values are selected, use the __in suffix
  const entries = Object.entries(filters as Record<string, string | string[]>)
  for (const [key, value] of entries) {
    if (value === undefined || value === null) continue
    if (Array.isArray(value)) {
      if (value.length === 0) continue
      if (value.length === 1) {
        params[key] = value[0]
      } else {
        params[`${key}__in`] = value.join(',')
      }
    } else {
      params[key] = value
    }
  }

  const response = await api.get('/workforce/profile-changes/', { params })
  return response.data
}
